import { ChangeEvent, SetStateAction, Dispatch, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";

export const WebapplicationModal = (props: {
  showModal: boolean;
  handleCloseAddModal: () => void;
  handleModalTitle: string;
  appName: string;
  currentAppName: string;
  setEditing: Dispatch<SetStateAction<boolean>>;
  setAppName: (appName: string) => void;
  editing: boolean;
  handleInputValue: string;
  setCurrentVersion: (string: string) => void;
  currentVersion: string;
  handleSubmit: () => void;
  validateForm: boolean;
}) => {
  const {
    showModal,
    handleCloseAddModal,
    handleModalTitle,
    appName,
    currentAppName,
    setAppName,
    editing,
    handleInputValue,
    setCurrentVersion,
    currentVersion,
    handleSubmit,
    setEditing,
    validateForm,
  } = props;

  const [applicationNameError, setApplicationNameError] = useState(false);
  const [applicationVersionError, setApplicationVersionError] = useState(false);

  const handleResetFormErrorsOnClose = () => {
    handleCloseAddModal();
    setApplicationNameError(false);
    setApplicationVersionError(false);
    setAppName("");
    setCurrentVersion("");
  };
  const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/[\w.-]*)*\/?$/;

  const handleSubmitFormWithErrors = () => {
    if (validateForm) {
      if (
        currentAppName !== "" &&
        currentVersion !== "" &&
        urlRegex.test(currentVersion)
      ) {
        setEditing(true);
        handleSubmit();
        setApplicationNameError(false);
        setApplicationVersionError(false);
        handleCloseAddModal();
      } else {
        if (
          currentAppName === "" &&
          (currentVersion === "" || !urlRegex.test(currentVersion))
        ) {
          setApplicationNameError(true);
          setApplicationVersionError(true);
        }
        if (currentAppName === "") {
          setApplicationNameError(true);
        } else if (currentVersion === "" || !urlRegex.test(currentVersion)) {
          setApplicationVersionError(true);
        }
      }
    } else {
      if (
        appName !== "" &&
        currentVersion !== "" &&
        urlRegex.test(currentVersion)
      ) {
        setEditing(true);
        handleSubmit();
        setApplicationNameError(false);
        setApplicationVersionError(false);
        handleCloseAddModal();
      } else {
        if (
          appName === "" &&
          (currentVersion === "" || !urlRegex.test(currentVersion))
        ) {
          setApplicationNameError(true);
          setApplicationVersionError(true);
        }
        if (appName === "") {
          setApplicationNameError(true);
        }
        if (currentVersion === "" || !urlRegex.test(currentVersion)) {
          setApplicationVersionError(true);
        }
      }
    }
  };

  const handleApplicationNameInputOnChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setAppName(e.target.value);
    setApplicationNameError(false);
  };

  const handleApplicationVersionInputOnChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setCurrentVersion(e.target.value);
    setApplicationVersionError(false);
  };

  return (
    <Modal
      className={`${
        showModal ? "popUpModal details-modal-opened" : "popUpModal"
      }`}
      keyboard={false}
      centered={true}
      scrollable={true}
      onHide={handleResetFormErrorsOnClose}
      show={showModal}
      size="lg"
    >
      <form onSubmit={(e) => e.preventDefault()} className="modal-content">
        <Modal.Header>
          <Modal.Title>{handleModalTitle}</Modal.Title>
          <CloseButton onClick={handleResetFormErrorsOnClose} />
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-lg-6">
              <label className="form-label">
                Application name{" "}
                {!editing && <span className="error-span">*</span>}
              </label>
              <input
                onChange={(e) => handleApplicationNameInputOnChange(e)}
                type="text"
                // disabled={editing}
                value={handleInputValue}
                maxLength={20}
                className={`form-control ${
                  applicationNameError ? "error-input" : ""
                }`}
                placeholder="Application name"
              />
              {applicationNameError ? (
                <span className="error-span">This Field is Required</span>
              ) : (
                <></>
              )}
            </div>
            <div className="col-lg-6">
              <label className="form-label">
                Application URL <span className="error-span">*</span>
              </label>
              <input
                onChange={(e) => handleApplicationVersionInputOnChange(e)}
                type="text"
                maxLength={60}
                value={currentVersion}
                className={`form-control ${
                  applicationVersionError ? "error-input" : ""
                }`}
                placeholder="Application URL"
              />
              {applicationVersionError ? (
                <span className="error-span">
                  {currentVersion === "" && "This Field is Required"}
                  {currentVersion !== "" &&
                    !urlRegex.test(currentVersion) &&
                    "Url should be like www.example.com"}
                </span>
              ) : (
                <></>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-4">
          <button
            type="submit"
            onClick={handleSubmitFormWithErrors}
            className="btn btn-primary"
          >
            Submit
          </button>
          <button
            onClick={handleResetFormErrorsOnClose}
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
